<template>
  <div id="app0">

    <pannel-header></pannel-header>

    <!-- <hello-world></hello-world> -->
    <!-- <pannel-content v-bind:soft='"easyicon"'></pannel-content> -->
    <!-- <image-demo></image-demo> -->

    <router-view />
    <!-- <router-link :to="{name:'soft', params: { id: 'easyicon' }}">跳转</router-link>
    <router-link :to="{path:'/soft', query: { id: 'easyicon' }}">跳转</router-link> -->

  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'
import PannelHeader from './components/PannelHeader.vue'
import PannelContent from './components/PannelContent.vue'
import PannelHome from './components/PannelHome.vue'
// import ImageDemo from './components/ImageDemo.vue'
import PannelMessage from './components/PannelMessage.vue'
export default {
  components: { HelloWorld, PannelHeader, PannelContent, PannelHome, PannelMessage/*, ImageDemo*/ },
  name: 'App',

  data()
  {
    return {
      Height: window.innerHeight,
      Width: window.innerWidth
    }
  },

  mounted(){
  },
  created(){
  },
  methods: {
  },
}
</script>

<style>

.container {
    /* width: 100%; */
    /* max-width: 1366px!important; */
    min-width: 660px;
    padding: 0;
    border: 1px solid #e3e9ed;
    border-top: 0;
    margin: 1px;
    margin-top: 1px;

    max-width: calc(100vw - 4px);
    max-height: calc(100vh - 48px - 5px);
    overflow:auto;
}

/* 为div添加边框属性 */
.border{
  min-width: 10px;
  min-height: 10px;
  
  border:solid;
  border-width: 1px;
  border-color: gray;

  background: white;
}

/* 为div添加边框阴影属性 */
.shadow{
  /* width: 100%;
  height: 100%; */
  
  min-width: 10px;
  min-height: 10px;
  /* border:dashed; */
  /* border:solid; */
  border-radius: 10px;
  border-width: 1px;
  border-color: gray;

  background: white;
  /* background: yellow; */
  /* background: rgb(238, 238, 238); */

  /* box-shadow: 0 0 3px 0px #000 inset; */
  box-shadow: 0 0 5px 0px rgb(126, 125, 125);
}


</style>



// WEBPACK FOOTER //
// src/App.vue